module.exports = __webpack_public_path__ + "50f714f5c118d861e39988d008d6e26a.pdf";